import {ApplicationInsights} from '@microsoft/applicationinsights-web';
import {ReactPlugin} from '@microsoft/applicationinsights-react-js';

// Initialize React Plugin
const reactPlugin = new ReactPlugin();

// Get environment configuration
// Uses VITE_NODE_ENV to match standard Node.js convention
const environment = import.meta.env.VITE_NODE_ENV || import.meta.env.MODE || 'development';
const appVersion = import.meta.env.VITE_APP_VERSION || '1.0.0';

// Initialize Application Insights
const appInsights = new ApplicationInsights({
    config: {
        connectionString: import.meta.env.VITE_APP_INSIGHTS_KEY,
        extensions: [reactPlugin],
        // Enable automatic collection
        enableAutoRouteTracking: true, // Automatically track route changes (works with React Router v6+)
        enableCorsCorrelation: true, // Enable CORS correlation for distributed tracing
        enableRequestHeaderTracking: true, // Track request headers
        enableResponseHeaderTracking: true, // Track response headers
        enableAjaxErrorStatusText: true, // Include AJAX error status text
        enableUnhandledPromiseRejectionTracking: true, // Track unhandled promise rejections
        // Performance and sampling
        autoTrackPageVisitTime: true, // Track time spent on each page
        disableFetchTracking: false, // Track fetch requests
        disableAjaxTracking: false, // Track AJAX requests
        // Privacy and data collection
        disableCookiesUsage: false, // Allow cookies for session tracking
        enableDebug: import.meta.env.VITE_NODE_ENV === 'development', // Enable debug mode in development
    },
});

// Load Application Insights
appInsights.loadAppInsights();

// Add telemetry initializer to tag all telemetry with environment and app info
appInsights.addTelemetryInitializer((envelope) => {
    // Set cloud role name (identifies the application in App Insights)
    envelope.tags = envelope.tags || {};
    envelope.tags['ai.cloud.role'] = 'patient-dashboard-frontend';
    envelope.tags['ai.cloud.roleInstance'] = `frontend-${environment}`;

    // Add custom properties to all telemetry
    envelope.data = envelope.data || {};
    envelope.data.environment = environment;
    envelope.data.appVersion = appVersion;
    envelope.data.appType = 'frontend';

    return true;
});

// Export instances for use throughout the application
export {appInsights, reactPlugin};
